import { ReactNode } from 'react';
import { HStack, VStack } from 'reaction';
import './ProjectSection.css';

export interface ProjectSectionProps {
    children: ReactNode;
    image: string;
    imageAlt: string;
    imageWidth?: string;
    details: 'left' | 'right';
    backgroundImage: string;
    shade?: 'light' | 'dark';
}

export default function ProjectSection({
    children,
    image,
    imageAlt,
    imageWidth,
    backgroundImage,
    details,
    shade,
}: ProjectSectionProps) {
    function getBackgroundImage() {
        if (shade) {
            let direction: string;
            let color: string;

            if (details === 'left') direction = 'right';
            else direction = 'left';

            if (shade === 'dark') color = 'black';
            else color = 'white';

            const gradient = `linear-gradient(to ${direction}, ${color}, transparent)`;
            return `${gradient}, url(${backgroundImage})`;
        }
        return `url(${backgroundImage})`;
    }

    function getImage() {
        return (
            <img
                src={image}
                alt={imageAlt}
                className='project-image'
                style={{ width: imageWidth }}
            />
        );
    }

    return (
        <HStack className='project-section' style={{ backgroundImage: getBackgroundImage() }}>
            {details === 'right' && getImage()}

            <VStack align='start' className='project-details'>
                {children}
            </VStack>

            {details === 'left' && getImage()}
        </HStack>
    );
}
